export class UnhideInspectionTemplateError extends Error {
  constructor(
    message: string = 'Failed to unhide inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'UnhideInspectionTemplateError';
  }
}
